import React, { ChangeEvent, useEffect, useState } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, TextField, Typography, FormControl, MenuItem, InputAdornment, IconButton, Checkbox, InputLabel } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import KenButton from '../../../../GlobalComponents/KenButton';
import { AcademicRecords } from '../../../../interfaces/Profile';
import dayjs, { Dayjs } from 'dayjs';
import { enqueueSnackbar } from 'notistack';
import { getTypeofGradePicklistValue, getTypeofStudyPicklistValue, postAcademicRecords } from '../../../../Utils/apiService';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '576px', xl: '576px' },
  padding: '20px 0px 20px 20px',
};
const AddAcademicRecord = (props: any) => {
  const classes = useStyles();
  const { userData, handleClose, setAcademicRecordStatus, editData } = props;
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [study, setStudy] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs(dayjs()));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(dayjs()));
  const [studyOptions, setStudyOptions] = useState<{ label: string; value: string }[]>([]); // State to store options
  const [gradeOptions, setGradeOptions] = useState<{ label: string; value: string }[]>([]); // State to store options
  console.log(startDate, endDate, "endDateendDateendDate");
  useEffect(() => {
    getTypeofStudyPicklistValue().then((res: any) => {
      console.log('res12345678909876543', res?.data?.data?.records);
      const options = res?.data?.data?.records.map((item: any) => ({
        label: item.Label,
        value: item.Value,
      }));
      setStudyOptions(options); // Set options in state
    })
    getTypeofGradePicklistValue().then((res: any) => {
      console.log('res12345678909876543', res?.data?.data?.records);
      const options = res?.data?.data?.records.map((item: any) => ({
        label: item.Label,
        value: item.Value,
      }));
      setGradeOptions(options); // Set options in state
    })
  }, []);
  const [formData, setFormData] = useState<AcademicRecords>({
    contactId: userData?.applicantId,
    typeOfStudy: '',
    percentage: 0,
    CGPA: '',
    fieldOfStudy: '',
    startDate: '',
    endDate: '',
    institute: '',
    marksheet: '',
    gradeType: '',
  });
  const [fileName, setFileName] = useState<string>('');
  const [base64Image, setBase64Image] = useState<string | null>(null);
  const [startDateError, setStartDateError] = useState<string | null>(null);
  const [endDateError, setEndDateError] = useState<string | null>(null);
  const [date, setdate] = useState(true)
  console.log(date, "datedatedatedatedate");

  useEffect(() => {
    if (editData != null) {
      setFormData({
        contactId: userData?.applicantId,
        typeOfStudy: editData.Type_of_Study__c,
        percentage: editData.Grade__c,
        CGPA: editData.Grade__c,
        fieldOfStudy: editData?.Field_of_study__c,
        startDate: editData.Start_Date__c,
        endDate: editData.End_Date__c,
        institute: editData.Name_of_the_institute__r?.Name,
        marksheet: '',
        gradeType: editData.Grade_Type__c,
      });
      setStudy(editData.Type_of_Study__c);
      setGrade(editData.Grade_Type__c);
      setStartDate(dayjs(editData.Start_Date__c));
      setEndDate(dayjs(editData.End_Date__c));
      setFileName(editData.MarkSheet_Name__c);
    }
  }, [editData]);

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    setStudy(value);

    // Clear error for "typeOfStudy" if valid
    setErrors((prevErrors) => ({
      ...prevErrors,
      typeOfStudy: value.trim() ? '' : prevErrors.typeOfStudy,
    }));
  };

  const handleChangeGrade = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    setGrade(value);

    // Clear error for "gradeType" if valid
    setErrors((prevErrors) => ({
      ...prevErrors,
      gradeType: value.trim() ? '' : prevErrors.gradeType,
    }));

    if (value === 'PERCENTAGE') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        percentage: 0, // Initialize percentage
      }));

      // Clear error for "CGPA" since it's not required
      setErrors((prevErrors) => ({
        ...prevErrors,
        CGPA: '',
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        CGPA: '', // Initialize CGPA
      }));

      // Clear error for "percentage" since it's not required
      setErrors((prevErrors) => ({
        ...prevErrors,
        percentage: '',
      }));
    }
  };

  const handleChangeStartDate = (newValue: Dayjs | null) => {
    setStartDate(newValue);
    setdate(true);

    if (newValue && endDate && newValue.isAfter(endDate)) {
      setStartDateError('Start date cannot be after the end date');
      setdate(false);
    } else {
      setStartDateError(null);

      // Clear error for "startDate" if valid
      setErrors((prevErrors) => ({
        ...prevErrors,
        startDate: newValue ? '' : prevErrors.startDate,
      }));
    }
  };

  const handleChangeEndDate = (newValue: Dayjs | null) => {
    setEndDate(newValue);
    setdate(true);

    if (newValue && startDate && newValue.isBefore(startDate)) {
      setEndDateError('End date cannot be before the start date');
      setdate(false);
    } else {
      setEndDateError(null);

      // Clear error for "endDate" if valid
      setErrors((prevErrors) => ({
        ...prevErrors,
        endDate: newValue ? '' : prevErrors.endDate,
      }));
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Check file size (5MB limit)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        enqueueSnackbar({ message: 'File size should not exceed 5MB', variant: 'error', autoHideDuration: 1000 });
        return;
      }

      // Check file type
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        enqueueSnackbar({ message: 'We accept only PDF, JPG, JPEG, and PNG files', variant: 'error', autoHideDuration: 1000 });
        return;
      }

      setFileName(file.name);

      // Clear error for "marksheet" if valid
      setErrors((prevErrors) => ({
        ...prevErrors,
        marksheet: '',
      }));

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const splitData = base64String.split(',');
        setBase64Image(splitData[1]);
        console.log('Base64 File: ', base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.institute) {
      newErrors.institute = "Institute name is required";
    }

    if (!formData.fieldOfStudy) {
      newErrors.fieldOfStudy = "Field of study is required";
    }

    if (grade === "PERCENTAGE" && !formData.percentage) {
      newErrors.percentage = "Percentage is required";
    }

    if (grade === "CGPA" && !formData.CGPA) {
      newErrors.CGPA = "CGPA is required";
    }

    if (!startDate) {
      newErrors.startDate = "Start date is required";
    }

    if (!endDate) {
      newErrors.endDate = "End date is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleChangeField = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? '' : prevErrors[name], // Clear error if value is not empty
    }));
    if (name === 'percentage') {
      const regex = /^(100|\d{0,2})$/;
      if (regex.test(value)) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value === '' ? null : Number(value),
        }));
      }
    }
   else if (name === 'CGPA') {
      const isValidCGPA = (input: string) => {
        if (input === '') return true; // Allow empty string
        const number = parseFloat(input);
        const dotCount = (input.match(/\./g) || []).length; // Count the number of dots
        return !isNaN(number) && number >= 0 && number <= 10 && dotCount <= 1;
      };

      if (isValidCGPA(value)) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value, // Keep as string to allow "1."
        }));
      }
    }
     else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const formatDate = (value: Dayjs | null): string => {
    if (value === null) {
      return '';
    }
    return value.format('YYYY-MM-DD');
  };
  const postAcademicsRecords = () => {
    if (!validateForm()) return;
    if (date === false) return;
    const dateValueStart: Dayjs | null = dayjs(startDate);
    const formattedStartDate = formatDate(dateValueStart);

    const dateValueEnd: Dayjs | null = dayjs(endDate);
    const formattedEndDate = formatDate(dateValueEnd);

    const payload: any = {
      ...formData,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      typeOfStudy: study,
      marksheet: base64Image,
      grade: Number(formData.percentage),
      gradeType: grade,
      marksheetName: fileName,
      // issueDate: formattedDate,
    };
    if(editData?.Id){
      payload.recordId = editData.Id;
    }
    postAcademicRecords(payload)
      .then((res) => {
        if (res?.success) {
          enqueueSnackbar({
            message: 'Academic Records Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          handleClose();
          setAcademicRecordStatus(true);
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        handleClose();
        console.error(err);
      });
  };
  return (
    <div>
      <Box sx={style}>
        <Typography
          sx={{
            textAlign: 'left',
            fontWeight: 500,
            fontSize: '15px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              fontSize: '12.5px !important',
            },
          }}
        >
        { editData != null?'Edit': 'Add' } Academic Records
        </Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Box
          sx={{
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '50vh',
            },
          }}
          className="scrollbar-cusgray"
        >
          <Grid container spacing={2} sx={{ marginTop: '-40px', paddingRight: '20px' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography
                sx={{
                  fontWeight: 500,
                  mt: 4,
                  fontSize: '12px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px !important',
                  },
                }}
              >
                Name of the institute<span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                sx={{
                  mt: 1.5,
                  borderRadius: '6px',
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    borderRadius: '6px',
                    fontSize: '12px',
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: '12px',
                  },
                }}
                size="small"
                id="outlined-basic"
                name="institute"
                value={formData.institute}
                onChange={handleChangeField}
                placeholder="Enter School"
                variant="outlined"
                fullWidth
                error={!!errors.institute}
                helperText={errors.institute}
              />
              <Typography
                sx={{
                  fontWeight: 500,
                  mt: 4,
                  fontSize: '12px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px !important',
                  },
                }}
              >
                Field of study<span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                sx={{
                  mt: 1.5,
                  borderRadius: '6px',
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    borderRadius: '6px',
                    fontSize: '12px',
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: '12px',
                  },
                }}
                size="small"
                id="outlined-basic"
                name="fieldOfStudy"
                value={formData.fieldOfStudy}
                onChange={handleChangeField}
                placeholder="Enter field of study"
                variant="outlined"
                fullWidth
                error={!!errors.fieldOfStudy}
                helperText={errors.fieldOfStudy}
              />
              <Typography
                sx={{
                  fontWeight: 500,
                  mt: 4,
                  fontSize: '12px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px !important',
                  },
                }}
              >
                Start Date
              </Typography>
              <Box sx={{ mt: 1.5 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    value={startDate}
                    onChange={handleChangeStartDate}
                    slots={{
                      textField: (params) => (
                        <TextField
                          {...params}
                          size="small"
                          fullWidth
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              height: '36px',
                              borderRadius: '6px',
                              fontSize: '12px',
                            },
                            '& .MuiOutlinedInput-input': {
                              fontSize: '12px',
                            },
                          }}
                        />
                      ),
                    }}
                  />
                </LocalizationProvider>
                {startDateError && <Typography style={{ color: 'red', fontSize: '12px' }}>{startDateError}</Typography>}
              </Box>
              <Typography
                sx={{
                  fontWeight: 500,
                  mt: 4,
                  fontSize: '12px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px !important',
                  },
                }}
              >
                Upload marksheets(optional)
              </Typography>
              <TextField
                sx={{
                  mt: 1.5,
                  borderRadius: '6px',
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    borderRadius: '6px',
                    fontSize: '12px',
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: '12px',
                  },
                }}
                variant="outlined"
                fullWidth
                size="small"
                placeholder="Upload Image"
                value={fileName}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton component="label">
                        <input
                          type="file"
                          hidden
                          accept="application/pdf" // Restrict file picker to allowed formats
                          onChange={handleFileChange}
                        />
                        <FileUploadOutlinedIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography
                sx={{
                  fontWeight: 500,
                  mt: 4,
                  fontSize: '12px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px !important',
                  },
                }}
              >
                Type of Study<span style={{ color: "red" }}> *</span>
              </Typography>
              <FormControl fullWidth error={!!errors.typeOfStudy}>
                <Select
                  labelId="type-of-study-label"
                  id="type-of-study-select"
                  value={study}
                  onChange={handleChange}
                  size="small"
                  sx={{
                    marginTop: 1.5,
                    height: '36px',
                    fontSize: '12px',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF',
                    },
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                      fontSize: '12px',
                    },
                    '& .MuiSvgIcon-root': {
                      fontSize: '12px',
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300, // Set max height for the dropdown
                        overflowY: 'auto', // Enable vertical scrolling
                        '& .MuiMenuItem-root': {
                          fontSize: '12px', // Set font size for menu items
                        },
                      },
                    },
                  }}
                >
                  {studyOptions.map((option, index) => (
                    <MenuItem
                      key={index}
                      value={option.value}
                      sx={{
                        '&.Mui-selected': {
                          backgroundColor: 'transparent',
                        },
                        '&.Mui-selected:hover': {
                          backgroundColor: 'transparent',
                        },
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                        '&:active': {
                          backgroundColor: 'transparent',
                        },
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.typeOfStudy && <Typography style={{ color: 'red', fontSize: '12px' }}>{errors.typeOfStudy}</Typography>}
              </FormControl>
              <Typography
                sx={{
                  fontWeight: 500,
                  mt: 4,
                  fontSize: '12px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px !important',
                  },
                }}
              >
                Type of Grade<span style={{ color: "red" }}> *</span>
              </Typography>
              <FormControl fullWidth error={!!errors.gradeType}>
                <Select
                  labelId="type-of-grade-label"
                  id="type-of-grade-select"
                  value={grade}
                  onChange={handleChangeGrade}
                  size="small"
                  sx={{
                    marginTop: 1.5,
                    height: '36px',
                    fontSize: '12px',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF',
                    },
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                      fontSize: '12px',
                    },
                    '& .MuiSvgIcon-root': {
                      fontSize: '12px',
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300, // Set max height for the dropdown
                        overflowY: 'auto', // Enable vertical scrolling
                        '& .MuiMenuItem-root': {
                          fontSize: '12px', // Set font size for menu items
                        },
                      },
                    },
                  }}
                >
                  {gradeOptions.map((option, index) => (
                    <MenuItem
                      key={index}
                      value={option.value}
                      sx={{
                        '&.Mui-selected': {
                          backgroundColor: 'transparent',
                        },
                        '&.Mui-selected:hover': {
                          backgroundColor: 'transparent',
                        },
                        '&:hover': {
                          backgroundColor: 'transparent',
                        },
                        '&:active': {
                          backgroundColor: 'transparent',
                        },
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.gradeType && <Typography style={{ color: 'red', fontSize: '12px' }}>{errors.gradeType}</Typography>}
              </FormControl>
              {grade== "PERCENTAGE" ? (<>
                <Typography
                  sx={{
                    fontWeight: 500,
                    mt: 4,
                    fontSize: '12px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '11px !important',
                    },
                  }}
                >
                  {'Percentage'}<span style={{ color: "red" }}> *</span>
                </Typography>
                <TextField
                  sx={{
                    mt: 1.5,
                    borderRadius: '6px',
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                      borderRadius: '6px',
                      fontSize: '12px',
                    },
                    '& .MuiOutlinedInput-input': {
                      fontSize: '12px',
                    },
                  }}
                  size="small"
                  id="outlined-basic"
                  placeholder="Enter percentage"
                  name={'percentage' }
                  value={ formData.percentage}
                  onChange={handleChangeField}
                  variant="outlined"
                  fullWidth
                  error={!!errors.percentage}
                  helperText={errors.percentage}
                />
              </>) : grade== "CGPA" ?
              (<>
                <Typography
                  sx={{
                    fontWeight: 500,
                    mt: 4,
                    fontSize: '12px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '11px !important',
                    },
                  }}
                >
                  {'CGPA'} <span style={{ color: "red" }}> *</span>
                </Typography>
                <TextField
                  sx={{
                    mt: 1.5,
                    borderRadius: '6px',
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                      borderRadius: '6px',
                      fontSize: '12px',
                    },
                    '& .MuiOutlinedInput-input': {
                      fontSize: '12px',
                    },
                  }}
                  size="small"
                  id="outlined-basic"
                  placeholder="Enter CGPA"
                  name={'CGPA'}
                  value={formData.CGPA}
                  onChange={handleChangeField}
                  variant="outlined"
                  fullWidth
                  error={!!errors.CGPA}
                  helperText={errors.CGPA}
                />
              </>):null
              }
              <Typography
                sx={{
                  fontWeight: 500,
                  mt: 4,
                  fontSize: '12px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px !important',
                  },
                }}
              >
                End Date
              </Typography>
              <Box sx={{ mt: 1.5 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    value={endDate}
                    onChange={handleChangeEndDate}
                    slots={{
                      textField: (params) => (
                        <TextField
                          {...params}
                          size="small"
                          fullWidth
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              height: '36px',
                              borderRadius: '6px',
                              fontSize: '12px',
                            },
                            '& .MuiOutlinedInput-input': {
                              fontSize: '12px',
                            },
                          }}
                        />
                      ),
                    }}
                  />
                </LocalizationProvider>
                {endDateError && <Typography style={{ color: 'red', fontSize: '12px' }}>{endDateError}</Typography>}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, paddingRight: '20px' }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 2,
              borderRadius: '8px',
              width: 80,
              backgroundColor: 'transparent !important',
              color: 'black',
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
              '&:active': {
                backgroundColor: 'transparent !important',
              },
              '&:focus': {
                backgroundColor: 'transparent !important',
              },
              '&:focus-visible': {
                backgroundColor: 'transparent !important',
              },
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Cancel
            </Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{ marginTop: 15, borderRadius: '8px', width: 100, marginLeft: 10, boxShadow: 'none' }}
            fullWidth
            onClick={postAcademicsRecords}
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Save
            </Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default AddAcademicRecord;
